export default "__VITE_ASSET__550cadeb__"